import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import DemandeStore from "../DemandeStore"
import {observer} from "mobx-react"

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import UploadEntree from "./Parts/UploadEntree"

import moment from "moment"
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import { DatePicker, KeyboardDatePicker,MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';

import "moment/locale/fr";

moment.locale("fr");

@observer
export default class Rdv extends React.Component {
  constructor(props) {
    super(props);
    this.askInputs = this.askInputs.bind(this)
    this.askPayer = this.askPayer.bind(this)
    this.change_date_entree_vigueur = this.change_date_entree_vigueur.bind(this)
    this.prefillLocataire = this.prefillLocataire.bind(this)
    this.validateBTN = this.validateBTN.bind(this)
    this.handleValidateTextData = this.handleValidateTextData.bind(this)
    let params = window.location.search
    params =  new URLSearchParams(params)
    this.state= {
      bien_id: DemandeStore.bien,
      date: moment(),
      type: "",
      typeStr: "",
      date_entree_vigueur: moment(),
      payeur: "",
      locataires: [],
      locataire_email: "",
      locataire_nom: "",
      locataire_prenom: "",
      locataire_id: "",
      showDisponibilite: false
    }
  }
  componentDidMount(){

  }
  askPayer(){
    if(this.state.type==""){
      return (<div></div>)
    }else{
    return(
        <div className="row">
            <div className="input-field s12">
              <select className="browser-default" value={this.state.payeur} onChange={(e)=> this.setState({payeur: e.target.value})}>
                <option value="">Qui paie ?</option>
                <option value="locataire">à charge totale du locataire</option>
                <option value="proprietaire">à charge totale du proprietaire</option>
                <option value="partage">Partagé à 50 50</option>
              </select>
            </div>
        </div>
      )
    }
  }
  validateBTN(){
    if(this.state.type =="" || this.state.payeur=="" || this.state.locataire_email==""){
      return (<div></div>)
    }else{
      return (<div class="row">
        <div className="col s4 offset-s8">
        <a href="" onClick={this.handleValidateTextData} className="btn btn-large">Valider le rendez-vous</a>

        </div>

      </div>
      )
    }
  }
  handleValidateTextData(e){
    e.preventDefault()

    axios.post("/api/v1/experts/app/demandesManuels/submit",{dates: [],donnees: this.state,date_entree_vigueur: this.state.date_entree_vigueur.utc()}).then((data)=>{
      let d = data.data
      axios.post("/api/v1/experts/rdv/validateDate",{duree: d.duree, date: this.state.date.format("YYYY-MM-DDTH:m:00.000+02:00"),demande: d.id}).then((data)=>{
        document.location.replace("/experts/demandes/index")
      })
    })
  }
  change_date_entree_vigueur(date){
    this.setState({
      date_entree_vigueur: date
    });
  }
  componentWillUnmount(){
  }
  prefillLocataire(e){
    let loc = this.state.locataires[e.target.value]
    this.setState({
      locataire_id: e.target.value,
      locataire_prenom: loc.prenom,
      locataire_nom: loc.nom,
      locataire_email: loc.email,
    })
  }
  askLocataire(){
  if(this.state.bien_id=="" || this.state.type==""){
      return (<div></div>)
    }else{
     return (
        <div className="row container">
          <h2>Information sur le locataire</h2>

          <select className="browser-default" onChange={this.prefillLocataire} value={this.state.locataire_id} id="">
            <option value="">Locataire</option>
            {this.state.locataires.map((loc,index)=>(
                <option key={index} value={index}>{loc.prenom} {loc.nom}</option>
              ))}
          </select>
              <div>
              <div className="row">
                  <div className="input-field col s6">
                      <input type="text" value={this.state.locataire_prenom} onChange={(e) => this.setState({locataire_prenom: e.target.value})}id="loc_prenom"/>
                      <label htmlFor="loc_nom">Prénom du locataire</label>
                </div>
                <div className="input-field col s6">
                  <input type="text" value={this.state.locataire_nom} onChange={(e) => this.setState({locataire_nom: e.target.value})}id="loc_nom"/>
                  <label htmlFor="loc_nom">Nom du locataire</label>
                </div>
              </div>
              <div className="row">
                <div className="input-field col s12">
                  <input type="email" value={this.state.locataire_email} onChange={(e) => this.setState({locataire_email: e.target.value})}id="loc_nom"/>
                  <label htmlFor="loc_email">Email du locataire</label>
                </div></div>

              </div>
        </div>
      )
    }
  }
  askInputs(){
    if(this.state.type==""){
      return (<div></div>)
    }else{
      if(this.state.type.titre.includes("entrée")){
        return(
            <div>

              <h2 className="center">Pour une entrée</h2>
              {/*<p>Veuillez remplir tout les champs pour que l'expertise d'entrée puisse avoir lieu !</p>*/}
              <div className="row container">
              <div className="col s6">
               <DatePicker
                autoOk
                variant="inline"
                label="Date d'entrée en vigueur du bail"
                value={this.state.date_entree_vigueur}
                format="DD-MM-YYYY"
                onChange={(date)=>this.setState({date_entree_vigueur: date})}
                />
              </div>
              <div className="col s6">
                 {this.askPayer()}
              </div>
              </div>
            </div>
          )
      }else if(this.state.type.titre.includes("sortie")){
        return(
          <div className="container">
            <h1 className="center">Sortie</h1>
              <div className="row">
              <div className="col s6">
               <DatePicker
                autoOk
                label="Date d'entrée en vigueur du bail"
                value={this.state.date_entree_vigueur}
                format="DD-MM-YYYY"
                onChange={(date)=>this.setState({date_entree_vigueur: date})}
                />
              </div>
              <div className="col s6">
                  {this.askPayer()}

              </div>
              </div>
            <UploadEntree bien={this.state.bien_id} />
          </div>)
      }else{
        return(
          <p>Merci de ne pas faire n'importe quoi avec ce formulaire ! </p>
          )
      }
    }
  }
  render () {
    if(this.state.showDisponibilite){
      return(
        <p> Une erreur est survenue </p>
        )

    }else{
      return (
        <React.Fragment>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"fr"}>

        <div className="row container">
        <div className="col s6">
            <div className="input-field">
                <KeyboardDateTimePicker
                variant="inline"
                ampm={false}
                label="Date et heure"
                value={this.state.date}
                onChange={(date)=>this.setState({date: date})}
                onError={console.log}
                format="DD/MM/YYYY HH:mm"
                />
           </div>

        </div>
        <div className="input-field col s6">
          <select className="browser-default" value={this.state.typeStr} onChange={(e)=>this.setState({type: JSON.parse(e.target.value),typeStr: e.target.value})} >
          <option value="" disabled>type de demande</option>
          {DemandeStore.typededemandes.map((type)=>(
          <option key={type.id} value={JSON.stringify(type)}>{type.titre}</option>
          ))}
          </select>
          </div>
        </div>
        {this.askInputs()}
        {this.askLocataire()}
        {this.validateBTN()}

        <ToastContainer
          position="top-right"
          autoClose={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable={false}
          />
        </MuiPickersUtilsProvider>
        </React.Fragment>
      );
    }
  }
}

